<template>
    <div v-if="Object.keys(nameservers).length">
        <h2>Edit Nameservers</h2>
        <div v-for="(ns, index) in nameservers">
            <txt v-model="nameservers[index]"></txt>
        </div>
        <button @click="addNS" class="btn btn-secondary"><i class="icon icon-plus"></i> Add Nameserver</button>
        <button class="btn btn-primary" @click.prevent="updateNS(nameservers)">Update NS</button>
        <span v-if="notif" class="alert" :class="notifClass" style="display: block;">{{ notif.msg }}</span>
    </div>
</template>
<script>
    export default {
        props: ['updateNS', 'id'],
        watch: {
            /*model: {
                handler: function (val, oldVal) {
                    this.$emit('input', this.model);
                },
                deep: true
            }*/
        },
        data() {
            return {
                notif: false,
                nameservers: {}
//                model: {},
            }
        },
        created() {
            this.$eventHub.$on('updateNameservers', this.loadNS);
            this.$eventHub.$on('nsNotify', this.notify);
//            this.model = this.value;
        },
        computed: {
            notifClass() {
                if (!this.notif) return '';
                return 'alert-' + this.notif.type;
            }
        },
        methods: {
            notify(id, type, msg) {
                if (this.id !== id) return;
                this.notif = {
                    type: type,
                    msg: msg
                };
            },
            addNS() {
                let count = Object.keys(this.nameservers).length;
                count += 1;
                if (count === 9) return;
                let object = {};
                object['ns' + count] = '';
                this.nameservers = Object.assign({}, this.nameservers, object);
            },
            loadNS(id, ns) {
                if (id !== this.id) return;
                this.nameservers = ns;
            },
            reset() {
                this.notif = false;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('updateNameservers', this.loadNS);
            this.$eventHub.$off('nsNotify', this.notify);
        }
    }
</script>